import React, { useEffect, useRef, useState } from 'react';

const Stats = () => {
  const [counts, setCounts] = useState({ products: 0, countries: 0, time: 0, genuine: 0 });
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated) {
          setAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [animated]);

  const animateCounters = () => {
    const targets = { products: 1000, countries: 40, time: 24, genuine: 100 };
    const duration = 1200;
    const stepTime = 20;
    const steps = duration / stepTime;

    const start = { products: 0, countries: 0, time: 0, genuine: 0 };
    const increment = {
      products: targets.products / steps,
      countries: targets.countries / steps,
      time: targets.time / steps,
      genuine: targets.genuine / steps,
    };

    let current = { ...start };
    let count = 0;
    const timer = setInterval(() => {
      count++;
      current.products += increment.products;
      current.countries += increment.countries;
      current.time += increment.time;
      current.genuine += increment.genuine;

      setCounts({
        products: Math.floor(current.products),
        countries: Math.floor(current.countries),
        time: Math.floor(current.time),
        genuine: Math.floor(current.genuine),
      });

      if (count >= steps) {
        setCounts({ products: targets.products, countries: targets.countries, time: targets.time, genuine: targets.genuine });
        clearInterval(timer);
      }
    }, stepTime);
  };

  return (
    <section className="stats" id="stats" ref={sectionRef}>
      <div className="container">
        <div className="stats-grid">
          <div className="stat-item reveal">
            <div className="number">{counts.products}<span className="suffix">+</span></div>
            <div className="label">Products Available</div>
          </div>
          <div className="stat-item reveal reveal-delay-1">
            <div className="number">{counts.countries}<span className="suffix">+</span></div>
            <div className="label">Countries Served</div>
          </div>
          <div className="stat-item reveal reveal-delay-2">
            <div className="number">{counts.time}<span className="suffix">h</span></div>
            <div className="label">Response Time</div>
          </div>
          <div className="stat-item reveal reveal-delay-3">
            <div className="number">{counts.genuine}<span className="suffix">%</span></div>
            <div className="label">Genuine Parts</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;